





import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class App extends Vue {
  get id () {
    return this.$route.query?.leadListId as string
  }

  get agencyTheme () {
    return this.$store.getters.agent?.agency?.globalSettings?.marketRadar?.colorScheme?.color1
  }

  async created () {
    this.$store.dispatch('getPropertyCategories')
    if (this.id) {
      const agent = await this.$store.dispatch('loadAgentInfo', this.id)
      const agencyTheme = this.agencyTheme || agent?.agency?.globalSettings?.marketRadar?.colorScheme?.color1
      if (agencyTheme) {
        this.$store.commit('setAgencyTheme', agencyTheme)
        document.body.style.setProperty('--primary', agencyTheme)
      }
    }
  }
}
